import EmployeeProductivityReportItem  from '@/store/entities/employee_productivity_report_item';

export default class EmployeeProductivityReportOutput {
    warehouseName : string;
    items : Array<EmployeeProductivityReportItem>;
}